import React, { useState, useEffect } from 'react';
import { Button, Card, CardHeader, Table, Container, Row, Col, Form, FormGroup, InputGroupAddon, InputGroupText, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, Badge, Label } from "reactstrap";
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../../api';
import Cookies from 'js-cookie';

const Leavetable1 = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [modal, setModal] = useState(false);

    // getting id for leave details
    const { id } = useParams();

    const [leaveDetails, setLeaveDetails] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const company_id = Cookies.get('company_id');
                const response = await api.get(`leaveEmpDetails.php?id=${id}&company_id=${company_id}`);
                // Ensure response.data is always an array
                const data = Array.isArray(response.data) ? response.data : [response.data];
                setLeaveDetails(data);
                console.log(data);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLeaveDetails([]);
            }
        };
        fetchData();
    }, [id]);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const toggleProjectDropdown = () => {
        setProjectDropdownOpen(!projectDropdownOpen);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container fluid>
                    <Row className='mb-5'>
                        <Link to="/general-admin/general-management/leave1">
                            <i className="fa-solid fa-right-from-bracket ml-4 mt-2" style={{ transform: 'rotate(180deg)', fontSize: '30px' }}></i>
                        </Link>

                        <Col className="order-xl-2 mb-5 mb-xl-0 text-center">
                            <h1>Employee Leave Details</h1>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col className="mb-5 mb-xl-0" xl="12">
                            <Card className="" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">Leave Details</h3>
                                        </div>
                                    </Row>
                                </CardHeader>

                                <div className="table-responsive">
                                    <Table className="align-items-center table-flush">
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col">Field Name</th>
                                                <th scope="col">Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leaveDetails && leaveDetails.length > 0 ? (
                                                leaveDetails.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td>Employee Email</td>
                                                            <td>{item.email || "N/A"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Employee Contact</td>
                                                            <td>{item.phoneno || "N/A"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Leave type</td>
                                                            <td>{item.leave_type || "N/A"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Leave From</td>
                                                            <td>{item.start_date || "N/A"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Leave To</td>
                                                            <td>{item.end_date || "N/A"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Leave Applied On</td>
                                                            <td>{item.applied_date || "N/A"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Status</td>
                                                            <td>
                                                                <Badge
                                                                    style={{
                                                                        backgroundColor:
                                                                            (item.status || "").trim().toLowerCase() === "approved"
                                                                                ? "#28a745" // green
                                                                                : ["rejected", "reject"].includes((item.status || "").trim().toLowerCase())
                                                                                    ? "#dc3545" // red
                                                                                    : "#F7D800", // yellow for pending/others
                                                                        color: "black"
                                                                    }}
                                                                    className="p-2"
                                                                >
                                                                    {item.status || "Pending"}
                                                                </Badge>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Leave Description</td>
                                                            <td>{item.content_des || "No description provided"}</td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2" style={{ textAlign: 'center' }}>No leave details found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default Leavetable1; 